<template>
    <div class="pcenter" style="flex-flow: column;">
      <div style="width:400px;height: 600px; background: #c0a16b;" id="capture">
        <img id="img1" style="width:400px;height: 600px;  position: absolute; z-index: 0;" :src="getImage(bgurl,'img1')" />
        <div style="position: absolute; margin-left: 130px; margin-top: 70px; z-index: 99; color:#d69434; font-size: 22px;">2020 开业大吉</div>
        <div style="position: absolute; margin-left: 130px; top: 430px; z-index: 99;" id="qrcode" ref="qrcode"></div>
      </div>
      <div style="margin-top: 20px;">
        <el-button @click="downbar">下载二维码</el-button>
        <el-button @click="downbar">下载海报</el-button>
      </div>
    </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import html2canvas from 'html2canvas'
  export default {
    name: 'BarCodeInfo',
    data () {
      return {
        bgcss: '',
        imgUrl: '',
        nickname: '',
        txurl: 'https://sqpro.oss-cn-beijing.aliyuncs.com/admin/img/tx.jpg',
        bgurl: 'https://sqpro.oss-cn-beijing.aliyuncs.com/ecomm/bg/newshop.jpg'
      }
    },
    mounted () {
      this.nickname = localStorage.getItem('userimg')
      if (localStorage.getItem('userimg') === null || localStorage.getItem('userimg') === '') {
        this.txurl = 'https://sqpro.oss-cn-beijing.aliyuncs.com/admin/img/tx.jpg'
      }
      this.bgcss = 'width:400px;height: 600px; position: relative; background: url(' + this.getImage(this.bgurl,'img1') + ') no-repeat;background-size:100%;'
    },
    methods: {
      getcode(url) {
        document.getElementById('qrcode').innerHTML = ''
        var qrcode = new QRCode('qrcode', {
          width: 128,
          height: 128,
          colorDark : '#fff',
          colorLight : '#9a0000',
          correctLevel : QRCode.CorrectLevel.H,
          text: url // 生成二维码的链接
        })
        window.console.log(qrcode)
      },
      getImage:function (url,imgId) {
        var xhr = new XMLHttpRequest();
        xhr.open('get', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          if (this.status === 200) {
            document.getElementById(imgId).src = URL.createObjectURL(this.response);
          }
        };
        xhr.send();
      },
      downbar () {
        /*
        let image = new Image()
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = this.bgurl
        image.onload = () => {
          var canvas = document.querySelector('#capture')
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, image.width, image.height)
        }
        document.getElementById('capture').style.backgroundImage = 'url("' + this.bgurl + '")';
         */
        html2canvas(document.querySelector('#capture'),{
          useCORS: true,
          allowTaint: false,
          tainttest:true
        }).then(canvas => {
          // 转成图片，生成图片地址
          this.imgUrl = canvas.toDataURL('image/jpg');
          this.saveFile(this.imgUrl, new Date().toLocaleString())
          console.log(this.imgUrl);
        });
      },
      saveFile(data, filename) {
        var savelink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        savelink.href = data;
        savelink.download = filename;
        const event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        savelink.dispatchEvent(event);
      }
    }
  }
</script>

<style scoped>
  #qrcode {
    height: 130px;
    width: 130px;
    border: 1px #fff solid;
    border-radius:5px 0;
  }
  #capture1 {
    width:400px;
    height: 600px;
    position: relative;
    background: url('https://sqpro.oss-cn-beijing.aliyuncs.com/ecomm/bg/newshop.jpg') no-repeat;
    background-size:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/BarDownLoad.vue